import { BRANDS, type BrandKey } from './brand.config';

type Rule = { test: (u: URL) => boolean; brand: BrandKey };

// Detect by brand token anywhere in hostname so it works for
// production, staging, and local dev (e.g. trakmate.localhost).
const rules: Rule[] = [
  {
    test: (u) => u.hostname.toLowerCase().includes('trakmate'),
    brand: 'trakmate',
  },
  {
    test: (u) => u.hostname.toLowerCase().includes('propfit'),
    brand: 'propfit',
  },
];

export function resolveBrandFromUrl(
  urlLike: string,
  defaultKey: BrandKey = 'propfit'
): BrandKey {
  try {
    const url = new URL(urlLike, 'https://placeholder.local');
    const hit = rules.find((r) => r.test(url));
    return hit ? hit.brand : defaultKey;
  } catch {
    // URL parsing failed for malformed input; return default
    return defaultKey;
  }
}

export function getBrandTheme(urlLike: string) {
  const key = resolveBrandFromUrl(urlLike);
  return BRANDS[key];
}
